/* Qalbeen · HOVER · « Vos cadeaux, palier par palier » (sections/hover-home-offer.liquid).
   Ajoute .vu à l'arrivée à l'écran (la ligne dorée se remplit, les paliers s'allument l'un après l'autre).
   L'état réel du panier (paliers atteints, prochain cadeau, montant qui manque) est peint par assets/hover-cart.js. */
(function () {
  function init(c) {
    var l = Array.prototype.slice.call((c || document).querySelectorAll('[data-hvho]'));
    if (!l.length) return;
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) { l.forEach(function (x) { x.classList.add('vu'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vu'); io.unobserve(e.target); } }); }, { threshold: .35 });
    l.forEach(function (x) { io.observe(x); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
